import { jsx, jsxs } from "react/jsx-runtime";
import { SvgIcon, useTheme } from "@mui/material";
import { validateTidalLicense } from "../../base/index.js";
function Telephone(props) {
  const { viewBox = "0 0 48 48", size, sx: inputSx, ...rest } = props;
  const theme = useTheme();
  const sx = typeof size === "number" ? { fontSize: size, ...inputSx } : inputSx;
  return /* @__PURE__ */ jsxs(SvgIcon, { ...rest, "data-tidal": "TidalIllustration", "data-tidal-illustration": "Telephone", sx, viewBox, children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M32.9246 34.9502c0 2.85-2.4 5.25-5.325 5.325-10.95 0-19.87499-8.925-19.87499-19.875 0-2.925 2.39999-5.325 5.32499-5.325.375 0 .675 0 .975.075.45.075.9.225 1.35.45l.225.15 1.35 8.4-.225.15c-.675.6-1.35 1.05-2.175 1.275 1.35 3.6 4.275 6.45 7.875 7.875.225-.75.6-1.5 1.2-2.175l.225-.225 8.4 1.35.15.225c.225.375.375.9.45 1.35.075.225.075.6.075.975Z",
        fill: theme.vars.palette.primary.light
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M27.75 26.25c-4.95 0-9-4.05-9-9s4.05-9 9-9 9 4.05 9 9V18c0 .45-.375.75-.825.675-.375 0-.75-.375-.675-.825v-.675c0-4.125-3.375-7.5-7.5-7.5s-7.5 3.375-7.5 7.5 3.375 7.5 7.5 7.5c.525 0 .975-.075 1.425-.15.375-.075.825.15.9.6.075.45-.15.825-.6.9-.525.15-1.125.225-1.725.225Z",
        fill: theme.vars.palette.primary.dark
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M27.75 24c3.7279 0 6.75-3.0221 6.75-6.75s-3.0221-6.75-6.75-6.75S21 13.5221 21 17.25 24.0221 24 27.75 24Z",
        fill: theme.vars.palette.secondary.main
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M27.75 18c-.45 0-.75-.3-.75-.75V12c0-.45.3-.75.75-.75s.75.3.75.75v5.25c0 .45-.3.75-.75.75Z",
        fill: theme.vars.palette.primary.dark
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M27.75 18h-4.5c-.45 0-.75-.3-.75-.75s.3-.75.75-.75h4.5c.45 0 .75.3.75.75s-.3.75-.75.75Zm8.25.75c-.225 0-.375-.075-.525-.225-.3-.3-.3-.75 0-1.05l2.25-2.25c.3-.3.75-.3 1.05 0 .3.3.3.75 0 1.05l-2.25 2.25c-.15.15-.3.225-.525.225Z",
        fill: theme.vars.palette.primary.dark
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M35.9996 18.75c-.225 0-.375-.075-.525-.225l-2.25-2.25c-.3-.3-.3-.75 0-1.05.3-.3.75-.3 1.05 0l2.25 2.25c.3.3.3.75 0 1.05-.15.15-.3.225-.525.225Zm-4.275 4.5h2.325c.225 0 .375.075.525.15.15.075.15.225.15.375s-.075.3-.15.375c-.075.075-.225.15-.45.15h-3.225c-.225 0-.375-.075-.525-.15-.15-.075-.15-.3-.15-.45 0-.075.075-.225.15-.45s.15-.3.225-.375l1.05-1.05c.3-.3.525-.45.675-.6.225-.15.45-.375.6-.525.15-.15.3-.375.375-.525.075-.15.15-.375.15-.525 0-.225-.075-.375-.15-.525-.075-.15-.225-.3-.375-.375-.15-.075-.3-.15-.525-.15-.375 0-.675.15-.9.525 0 .075-.075.15-.15.375s-.15.375-.225.45c-.075.075-.225.15-.375.15s-.3-.075-.375-.15c-.075-.075-.15-.225-.15-.375 0-.225.075-.45.15-.6.075-.15.225-.45.375-.6.15-.15.375-.3.675-.45.3-.15.6-.15.975-.15.45 0 .825.075 1.125.225.225.075.375.225.525.375.15.15.3.375.375.6.075.225.15.45.15.675 0 .375-.075.675-.3.975-.225.3-.375.525-.525.675-.15.15-.525.45-.975.825-.45.375-.75.675-.9.825 0 .075-.075.15-.15.3Zm6.525.45v-.825h-2.25c-.3 0-.45-.075-.6-.225-.15-.15-.225-.3-.225-.525v-.15c0-.075.075-.15.075-.15s.075-.15.15-.15.075-.15.15-.225l2.325-3.15c.15-.225.3-.375.375-.45.075-.075.225-.15.375-.15.45 0 .675.225.675.75v3.375h.225c.225 0 .375 0 .525.075.15.075.225.225.225.375s-.075.3-.15.375c-.075.075-.3.15-.525.15h-.3v.825c0 .225-.075.375-.15.525-.075.15-.225.15-.375.15s-.3-.075-.375-.15c-.075-.075-.15-.225-.15-.45Zm-1.95-1.8h1.95v-2.55l-1.95 2.55Z",
        fill: theme.vars.palette.primary.dark
      }
    )
  ] });
}
Telephone.tidalIllustrationMeta = {
  categories: ["illustration"],
  name: "Telephone"
};
validateTidalLicense();
export {
  Telephone
};
//# sourceMappingURL=Telephone.js.map
